import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'

export const firebaseConfig = {
  apiKey: 'AIzaSyCnbq7GhXf6eQhLFMpLB3oOZugONOoa-48',
  authDomain: 'colozoo.firebaseapp.com',
  databaseURL: 'https://colozoo-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'colozoo',
  storageBucket: 'colozoo.firebasestorage.app',
  messagingSenderId: '396682587066',
  appId: '1:396682587066:web:0cfcfcd9e95f047e9f8b83',
  measurementId: 'G-N3RCR990WD'
}

export const firebaseApp = initializeApp(firebaseConfig)
export const auth = getAuth(firebaseApp)
export const db = getFirestore(firebaseApp)
export const storage = getStorage(firebaseApp)

// Suppress Firebase emulator warnings
if (typeof window !== 'undefined') {
  window.FIREBASE_EMULATOR_WARNING_SUPPRESS = true
}

// Connect to emulators in development (except Firestore and Storage which stay on production)
if (process.env.NODE_ENV === 'development') {
  try {
    // Auth emulator disabled to avoid warning banner
    // Storage emulator disabled - uses production
    // Note: Firestore intentionally NOT connected to emulator - uses production
  } catch (error) {
    console.log('Emulators already connected')
  }
}